import {
  GET_USER_TRIBUN_TOKEN_REQUEST,
  GET_USER_TRIBUN_TOKEN_SUCCESS,
  GET_USER_TRIBUN_TOKEN_FAILURE,
} from 'Store/constants';

const initialState = {
  data: '',
  isLoading: false,
  error: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case GET_USER_TRIBUN_TOKEN_REQUEST:
      return { ...state, isLoading: true, error: null };
    case GET_USER_TRIBUN_TOKEN_SUCCESS:
      return { ...state, data: action.payload?.token, isLoading: false, error: null };
    case GET_USER_TRIBUN_TOKEN_FAILURE:
      return { ...state, isLoading: false, error: action.payload };
    default:
      return state;
  }
};
